import _objectSpread from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectSpread";
var arrow = {
  marginLeft: 4,
  marginRight: 4,
  fontSize: 16,
  verticalAlign: 'middle',
  opacity: 0.6
};
var Styles = {
  arrowLight: _objectSpread({}, arrow, {
    color: 'rgba(255, 255, 255, 0.85)'
  }),
  arrowDark: _objectSpread({}, arrow, {
    color: 'rgba(0, 0, 0, 0.85)'
  }),
  link: {
    lineHeight: '24px',
    textDecoration: 'none',
    cursor: 'pointer',
    opacity: 0.85,
    '&:hover': {
      opacity: 1
    }
  },
  linkLight: {
    color: 'rgb(255, 255, 255)'
  },
  linkDark: {
    color: 'rgb(0, 0, 0)'
  },
  lastLink: {
    opacity: 1
  }
};
export default Styles;